import { Photo, Pipeline } from 'ff-canvas';

export const scalePlaceholder = (pipeline: Pipeline, photo: Photo) => {

    const { width, height } = pipeline.boundsOf(photo);
    const { scale } = pipeline.device.transform;

    return {
        width: Math.ceil(width * scale.x),
        height: Math.ceil(height * scale.y)
    };
};